// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignupModal_wrapper__oZ5B9","message":"SignupModal_message__2ni-P","childWrapper":"SignupModal_childWrapper__2iOAc"};